var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaLibraryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#666666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4444 10.8889C12.48 10.8889 10.8889 12.48 10.8889 14.4444C10.8889 16.4089 12.48 18 14.4444 18C16.4089 18 18 16.4089 18 14.4444C18 12.48 16.4089 10.8889 14.4444 10.8889ZM16.6133 15.04H15.0311V16.6222H13.8489V15.04H12.2667V13.8578H13.8489V12.2756H15.0311V13.8578H16.6133V15.04ZM14.8 6.31111C14.8 7.41333 13.9022 8.31111 12.8 8.31111C11.6978 8.31111 10.8 7.41333 10.8 6.31111C10.8 5.20889 11.6978 4.31111 12.8 4.31111C13.9022 4.31111 14.8 5.20889 14.8 6.31111ZM10.8889 10.48L9.82222 9.64444L8.22222 11.0667L5.11111 7.51111L3.6 10.5333V3.42222H16.4V9.48444C16.9956 9.71556 17.5289 10.0622 18 10.48V2.71111C18 2.32 17.6444 2 17.2 2H2.8C2.35556 2 2 2.32 2 2.71111V15.5111C2 15.9022 2.35556 16.2222 2.8 16.2222H9.42222C9.22667 15.6622 9.11111 15.0667 9.11111 14.4444C9.11111 12.8711 9.80444 11.4578 10.8889 10.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLibraryIcon);
export default __webpack_public_path__ + "static/media/mediaLibraryIcon.85e0524d9fce8620fb0305a95d1752e8.svg";
export { ForwardRef as ReactComponent };